const getAPIUrlBase = () => {
    return "https://localhost:7239"
}


export {getAPIUrlBase} 